import { Checkbox } from '@melements/front-components';
import styled from 'theme';

export const CheckboxWrapper = styled(Checkbox)`
  font-weight: ${props => props.theme.variables.fonts.weight.bold};
`;
